export default {
  default: [
    {
      path: "/spaarder",
      name: "funders.table",
      component: () => import("./views/FunderTableView.vue"),
    },
    {
      path: "/spaarder/aanmaken",
      name: "funders.create",
      component: () => import("./views/FunderFormView.vue"),
    },
    {
      path: "/spaarder/:id",
      name: "funders.view",
      component: () => import("./views/FunderDetailsView.vue"),
      redirect: { name: "funders.view.contracts" },
      children: [
        {
          path: "contracten",
          name: "funders.view.contracts",
          component: () => import("./views/FunderDetails/ContractsView.vue"),
        },
        {
          path: "accounts/:accountId",
          name: "funders.view.accounts.view",
          component: () => import("./views/FunderDetails/AccountView.vue"),
        },
        {
          path: "accounts",
          name: "funders.view.accounts",
          component: () => import("./views/FunderDetails/AccountsView.vue"),
        },
        {
          path: "details",
          name: "funders.view.details",
          component: () => import("./views/FunderDetails/DetailsView.vue"),
        },
      ],
    },
    {
      path: "/spaarder/:id/wijzigen",
      name: "funders.edit",
      component: () => import("./views/FunderFormView.vue"),
    },
  ],
};
